module.exports = __webpack_public_path__ + "665fea38a3e753647a3e849f89182322.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/Camps/camps3.jpg
// module id = 1209
// module chunks = 0